import { pointInPolygon } from "./pointInPolygon";

import { sections } from "../UniversitySections/geoSections";

 /**
  * Get selected section after user dragged pin
  * 
  * @param position 
  * @returns A, B, C... Section name
  */
 export const getSelectedSection = (position: [number, number]) => {
  let section = null;
  sections.forEach((sect) => {
      if (pointInPolygon(position, sect.arr)) section = sect.name;
  });

  return section;
};